module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-SemiBold.3525e8ef.ttf";